import React, { FC, memo } from "react";

import { SocBindCallbackScreen } from "../";

export const BindVkRedirect: FC = memo(() => <SocBindCallbackScreen network="vk" />);
